<template>
  <div>
    <AssignmentsList :version="assignmentsVersion" />

    <PackingSlipButtons />

    <PackingSlips v-if="showPackingSlips" :id="PACKING_SLIPS" />
    <CreatePackingSlip :id="PACKING_SLIP" />
    <CreatePackingSlipAssignmentsModal v-if="showCreatePackingSlip" :id="CREATE_PACKING_SLIP" />
    <PackingSlipPreviewModal :id="PACKING_SLIP_PREVIEW" />
    <PackingSlipEditModal :id="PACKING_SLIP_EDIT" />
  </div>
</template>

<script lang="ts">
import { computed, defineAsyncComponent, defineComponent, onBeforeMount, ref, watch } from 'vue'
import { SINGLE } from '@/const/AssignmentTypes'
import {
  CREATE_PACKING_SLIP,
  PACKING_SLIP,
  PACKING_SLIP_EDIT,
  PACKING_SLIP_PREVIEW,
  PACKING_SLIPS,
} from '@/const/ModalTypes'
import { registerModals } from '@/services/Modal'
import { useAssignmentStore } from '@/store/assignment'
import { usePackingSlipStore } from '@/store/packingSlip'
import { useVueNextModalStore } from '@/store/vueNextModal'

export default defineComponent({
  name: 'StaffAssignmentsList',
  components: {
    PackingSlips: defineAsyncComponent(() => import('@/views/Modals/PackingSlip/PackingSlipsModal.vue')),
    AssignmentsList: defineAsyncComponent(() => import('@/views/Components/Assignment/AssignmentsList.vue')),
    PackingSlipButtons: defineAsyncComponent(() => import('@/views/Components/PageParts/PackingSlipButtons.vue')),
    PackingSlipEditModal: defineAsyncComponent(() => import('@/views/Modals/PackingSlip/PackingSlipEditModal.vue')),
    PackingSlipPreviewModal: defineAsyncComponent(
      () => import('@/views/Modals/PackingSlip/PackingSlipPreviewModal.vue'),
    ),
    CreatePackingSlipAssignmentsModal: defineAsyncComponent(
      () => import('@/views/Modals/PackingSlip/CreatePackingSlipAssignmentsModal.vue'),
    ),
    CreatePackingSlip: defineAsyncComponent(() => import('@/views/Modals/PackingSlip/CreatePackingSlipModal.vue')),
  },
  setup() {
    const modalStore = useVueNextModalStore()
    const packingSlipStore = usePackingSlipStore()
    const assignmentStore = useAssignmentStore()

    const modals = computed(() => modalStore.renderedModals)
    const assignmentsVersion = computed(() => assignmentStore.version)

    const showPackingSlips = ref(false)
    const showCreatePackingSlip = ref(false)

    watch(
      modals,
      () => {
        showPackingSlips.value = modals.value.includes(PACKING_SLIPS)
        showCreatePackingSlip.value = modals.value.includes(CREATE_PACKING_SLIP)
      },
      { deep: true },
    )

    onBeforeMount(() => {
      registerModals(PACKING_SLIP)
      registerModals(PACKING_SLIPS)
      registerModals(PACKING_SLIP_EDIT)
      registerModals(PACKING_SLIP_PREVIEW)
      registerModals(CREATE_PACKING_SLIP)
      packingSlipStore.setAssignmentType(SINGLE)
    })

    return {
      showPackingSlips,
      showCreatePackingSlip,
      assignmentsVersion,
      CREATE_PACKING_SLIP,
      PACKING_SLIP,
      PACKING_SLIP_EDIT,
      PACKING_SLIP_PREVIEW,
      PACKING_SLIPS,
    }
  },
})
</script>
